import { render, staticRenderFns } from "./htgl.vue?vue&type=template&id=253d681c&scoped=true&"
import script from "./htgl.vue?vue&type=script&lang=js&"
export * from "./htgl.vue?vue&type=script&lang=js&"
import style0 from "./htgl.vue?vue&type=style&index=0&id=253d681c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253d681c",
  null
  
)

export default component.exports